module.exports = __webpack_public_path__ + "static/img/wxc.d031a3e.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/shops/wxc.png
// module id = NrIi
// module chunks = 1